<template>
    <div class="">
            <h1 class="text-muted mb-4">
                <i class="fa fa-file" aria-hidden="true"></i>
                <router-link class="ml-2 text-decoration-none" to="/products">
                    <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                    Products
                </router-link> 
                / {{product.name}}
            </h1>
            
        <div>
            <div class="d-flex justify-content-between">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Overview
                            </a>
                        </li>                       
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-sales-tab" 
                                data-toggle="pill" 
                                href="#pills-sales" 
                                role="tab" 
                                aria-controls="pills-sales" 
                                aria-selected="false">
                                Sales
                            </a>
                        </li>	
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-orders-tab" 
                                data-toggle="pill" 
                                href="#pills-orders" 
                                role="tab" 
                                aria-controls="pills-orders" 
                                aria-selected="false">
                                Orders
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-purchases-tab" 
                                data-toggle="pill" 
                                href="#pills-purchases" 
                                role="tab" 
                                aria-controls="pills-purchases" 
                                aria-selected="false"
                                @click="getPurchases()">
                                Purchases
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-transfers-tab" 
                                data-toggle="pill" 
                                href="#pills-transfers" 
                                role="tab" 
                                aria-controls="pills-transfers" 
                                aria-selected="false">
                                Transfers
                            </a>
                        </li>							
                </ul>
                <!-- add buttons -->
                <div class="mr-4">
                    <button class="btn btn-success">
                        Add Sale
                    </button>
                </div>
            </div>									
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab"> 
                    <div class="d-flex justify-content-start">                     
                        <div class="col-lg-5">                        
                            <div class="">
                                <hr>
                                <h4 class="text-muted">Stock details</h4>
                                <div class="d-flex justify-content-between">
                                    <label class="font-weight-bold">Minumum required</label>
                                    {{product.minimum_required}}
                                </div>
                                <div class="d-flex justify-content-between">
                                    <label class="font-weight-bold">Opening stock</label>
                                    {{product.stock}}
                                </div>
                                <hr>
                                <h4 class="text-muted">Primary details</h4>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">Item Type</label>
                                        {{product.product_type}}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">SKU</label>
                                        {{product.sku}}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">Tax</label>
                                        {{product.tax}}
                                    </div>
                                    <hr>
                                    <h4 class="text-muted">Sales information</h4>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">Wholesale price</label>
                                        {{product.wholesale_price | intcomma}}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">retail price</label>
                                        {{product.retail_price | intcomma}}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">Tax</label>
                                        {{product.tax}}
                                    </div>
                                    <hr>
                                    <h4 class="text-muted">Purchase information</h4>
                                    <div class="d-flex justify-content-between">
                                        <label class="font-weight-bold">purchase price</label>
                                        {{product.purchase_price | intcomma}}
                                    </div>                                
                            </div>
                        </div>  
                    </div>                                                                                     
                </div>
                <div class="tab-pane fade" id="pills-sales" role="tabpanel" aria-labelledby="pills-sales-tab">
                    <productSales :product_id="$route.params.product_id"/>
                </div>
                <div class="tab-pane fade" id="pills-orders" role="tabpanel" aria-labelledby="pills-orders-tab">
                    <productOrders :product_id="$route.params.product_id"/>
                </div>
                <div class="tab-pane fade" id="pills-purchases" role="tabpanel" aria-labelledby="pills-purchases-tab">
                   <productPurchases :product_id="$route.params.product_id"/>
                </div>                
            </div> 		  
        </div>	
    </div>
</template>
<script>
import productPurchases from './subviews/purchases'
import productSales from './subviews/sales'
import productOrders from './subviews/orders'
export default {
    name: 'productDetail',    
    components:{ productPurchases,productSales,productOrders },
    data(){
        return{
            sales:null,
            product : this.$route.query.product,
            from_date: null,
            to_date: null,
            //receipt modal.
            receipt_modal_data:null,
        }
    },
    mounted(){              
        this.from_date = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.to_date = this.$moment().format('YYYY-MM-DD')
        this.getSales()
    },
    computed:{     
        account_switched(){
            return this.$store.state.account_switch_count
        }
    },
    watch:{
        account_switched: function(){
            this.$router.push("/products")
        }
    },
    methods:{		        
        //get sales by user		
        getSales:function(){
            //convert date to unix timestamp
            var from_date = this.from_date//new Date(this.from_date).getTime()
            var to_date = this.to_date//new Date(this.to_date).getTime()
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/list-sales`,
                params:{
                    date0: from_date,
                    date1: to_date
                },
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{							
                this.sales = response.data		
            }).catch((err)=>{
                this.$emit('alert',err)
            })
        },
        totalCost: function(products){
            var total = 0.00
            for (var i in products){				
                total += parseFloat(products[i].total)
            }
            return total
        },
        totalPayment: function(payments){
            var total = 0.00
            for (var i in payments){
                total += parseFloat(payments[i].amount)
            }
            return total
        },
        openReceipt: function(sale){
            //create modal data
            this.receipt_modal_data = sale
            //open modal
            var button = document.getElementById('receipt-modal-button')
            button.click()
        }
    }
}
</script>